/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PatientDocument } from './PatientDocument';
import {
    PatientDocumentFromJSON,
    PatientDocumentFromJSONTyped,
    PatientDocumentToJSON,
} from './PatientDocument';

/**
 * 
 * @export
 * @interface EmailMultipleDocumentPayload
 */
export interface EmailMultipleDocumentPayload {
    /**
     * 
     * @type {string}
     * @memberof EmailMultipleDocumentPayload
     */
    cover_page?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailMultipleDocumentPayload
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof EmailMultipleDocumentPayload
     */
    subject?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailMultipleDocumentPayload
     */
    body?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmailMultipleDocumentPayload
     */
    document_ids?: Array<string>;
    /**
     * 
     * @type {PatientDocument}
     * @memberof EmailMultipleDocumentPayload
     */
    document?: PatientDocument;
}

/**
 * Check if a given object implements the EmailMultipleDocumentPayload interface.
 */
export function instanceOfEmailMultipleDocumentPayload(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function EmailMultipleDocumentPayloadFromJSON(json: any): EmailMultipleDocumentPayload {
    return EmailMultipleDocumentPayloadFromJSONTyped(json, false);
}

export function EmailMultipleDocumentPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailMultipleDocumentPayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cover_page': !exists(json, 'cover_page') ? undefined : json['cover_page'],
        'email': json['email'],
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
        'body': !exists(json, 'body') ? undefined : json['body'],
        'document_ids': !exists(json, 'document_ids') ? undefined : json['document_ids'],
        'document': !exists(json, 'document') ? undefined : PatientDocumentFromJSON(json['document']),
    };
}

export function EmailMultipleDocumentPayloadToJSON(value?: EmailMultipleDocumentPayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cover_page': value.cover_page,
        'email': value.email,
        'subject': value.subject,
        'body': value.body,
        'document_ids': value.document_ids,
        'document': PatientDocumentToJSON(value.document),
    };
}

